import type React from 'react';
import { useEffect } from 'react';

import { InstitutionFuturesProgressStep, InstitutionOnboardingProgressStep, useProgress } from '@/context/progress';
import { getDetailsKeyProgress, INSTITUTION_DETAILS_TYPE, type InstitutionDetailsKeyForDetailsType, type InstitutionDetailsType } from '@/features/institution/utils';
import BaseLayout from '@/layouts/base';

type InstitutionDetailsLayoutProps<T extends InstitutionDetailsType = InstitutionDetailsType> = React.ComponentPropsWithoutRef<typeof BaseLayout> & {
  detailsKey: InstitutionDetailsKeyForDetailsType<T>;
  detailsType: T;
};

const INSTITUTION_DETAILS_PROGRESS_STEP_MAP = {
  [INSTITUTION_DETAILS_TYPE.ONBOARDING]: InstitutionOnboardingProgressStep.INSTITUTION_INFORMATION,
  [INSTITUTION_DETAILS_TYPE.FUTURES]: InstitutionFuturesProgressStep.INSTITUTION_INFORMATION_FUTURES,
} as const;

const InstitutionDetailsLayout = <T extends InstitutionDetailsType>({ detailsKey, detailsType, ...props }: InstitutionDetailsLayoutProps<T>) => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(INSTITUTION_DETAILS_PROGRESS_STEP_MAP[detailsType], getDetailsKeyProgress(detailsType, detailsKey));
  }, [detailsKey, detailsType, setCurrentStep]);

  return <BaseLayout {...props} />;
};
InstitutionDetailsLayout.displayName = 'InstitutionDetailsLayout';

export default InstitutionDetailsLayout;
